var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0025 9.59794C13.9963 9.59794 14.8019 10.4036 14.8019 11.3974V12.1323C14.8019 12.591 14.6585 13.0383 14.3917 13.4116C13.1548 15.1425 11.135 16 8.3983 16C5.66104 16 3.64231 15.1421 2.40837 13.4103C2.14275 13.0376 2 12.5912 2 12.1335L2 11.3974C2 10.4036 2.80563 9.59794 3.79942 9.59794L13.0025 9.59794ZM8.3983 0C10.6078 0 12.399 1.79118 12.399 4.00071C12.399 6.21024 10.6078 8.00142 8.3983 8.00142C6.18877 8.00142 4.39759 6.21024 4.39759 4.00071C4.39759 1.79118 6.18877 0 8.3983 0Z",
    fill: "#B9BBBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic-user.f51f52ddb87b62485011161c536f6f5f.svg";
export { ForwardRef as ReactComponent };